module.exports = __webpack_public_path__ + "img/55.f10baf30.png";